<div class="usan-form-item gene-therapies-container">
  <div class="usan-checklist-item">
    <div class="usan-checklist-icon-column">
      <mat-icon>{{ wasFileUploaded ? 'check_circle' : 'radio_button_unchecked' }}</mat-icon>
    </div>
    <div class="usan-checklist-content-column flex-wrap">
      <span class="required-star" *ngIf="isDocumentRequired">*</span>
      <span class="usan-form-item gene-therapies-item gene-therapies-text">
        Gene Therapies (MS-Word Document)
      </span>
      <div class="break"></div>
      <div class="usan-form-item gene-therapies-item gene-therapies-text">
        <ul>
          <li>Required information for nucleic acid-based substances</li>
          <li>A schematic map of the entire vector and inserted gene(s)</li>
          <li>For the therapeutic protein: the complete precursor nucleotide gene-therapies with spaces between codons and translation (including the stop codon in 5&apos;), with numbers per line, and in a format that can be copied for analysis</li>
        </ul>
      </div>
    </div>
  </div>
  <div class="input-error" *ngIf="showRequiredError">
    This is a required document.
  </div>
  <div class="usan-form-item button-layout layout-centered">
    <button type="button" class="upload-gene-therapies form-btn form-btn-style form-btn-text"
      (click)="openDialog()">
      <mat-icon class="form-btn-icon">upload</mat-icon>
      Upload gene therapies
    </button>
  </div>
  <ng-container *ngIf="wasFileUploaded">
    <div class="full-width" *ngFor="let file of attachments">
      <app-uploaded-file [requiresAdmin]="false" [attachment]="file"></app-uploaded-file>
    </div>
  </ng-container>
</div>